import React, { useState, useEffect } from 'react';

const GridOverlay = ({ 
  gridSize = 20, 
  showCoordinates = true, 
  showElementBoundaries = true,
  isVisible = false 
}) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [gridLines, setGridLines] = useState([]);

  useEffect(() => {
    if (!isVisible) return;

    const updateMousePosition = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    const generateGridLines = () => {
      const lines = [];
      const width = window.innerWidth;
      const height = window.innerHeight;
      
      // Vertical lines
      for (let x = 0; x <= width; x += gridSize) {
        lines.push({
          type: 'vertical',
          x,
          y1: 0,
          y2: height
        });
      }
      
      // Horizontal lines
      for (let y = 0; y <= height; y += gridSize) {
        lines.push({
          type: 'horizontal',
          y,
          x1: 0,
          x2: width
        });
      }
      
      setGridLines(lines);
    };

    generateGridLines();
    
    // Use document instead of window for better event handling
    document.addEventListener('mousemove', updateMousePosition, { passive: true });
    window.addEventListener('resize', generateGridLines);

    return () => {
      document.removeEventListener('mousemove', updateMousePosition);
      window.removeEventListener('resize', generateGridLines);
    };
  }, [isVisible, gridSize]);

  if (!isVisible) {
    return null;
  }
  

  const gridX = Math.floor(mousePosition.x / gridSize) * gridSize;
  const gridY = Math.floor(mousePosition.y / gridSize) * gridSize;

  return (
    <div
      className="grid-overlay"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        pointerEvents: 'none',
        zIndex: 9999,
        opacity: 0.7
      }}
    >
      {/* Grid Lines */}
      {gridLines.map((line, index) => (
        <div
          key={index}
          style={{
            position: 'absolute',
            [line.type === 'vertical' ? 'left' : 'top']: line.type === 'vertical' ? line.x : line.y,
            [line.type === 'vertical' ? 'width' : 'height']: '1px',
            [line.type === 'vertical' ? 'height' : 'width']: line.type === 'vertical' ? '100vh' : '100vw',
            backgroundColor: '#ffff00',
            opacity: 0.3
          }}
        />
      ))}

      {/* Mouse Position Indicator */}
      <div
        style={{
          position: 'absolute',
          left: mousePosition.x + 10,
          top: mousePosition.y - 30,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          color: '#ffff00',
          padding: '4px 8px',
          borderRadius: '4px',
          fontSize: '12px',
          fontFamily: 'monospace',
          pointerEvents: 'none',
          zIndex: 10000
        }}
      >
        {showCoordinates && (
          <div>
            <div>Mouse: {mousePosition.x}, {mousePosition.y}</div>
            <div>Grid: {gridX}, {gridY}</div>
            <div>Cell: {Math.floor(mousePosition.x / gridSize)}, {Math.floor(mousePosition.y / gridSize)}</div>
          </div>
        )}
      </div>

      {/* Grid Cell Highlight */}
      <div
        style={{
          position: 'absolute',
          left: gridX,
          top: gridY,
          width: gridSize,
          height: gridSize,
          border: '2px solid #ff0000',
          backgroundColor: 'rgba(255, 0, 0, 0.1)',
          pointerEvents: 'none'
        }}
      />
    </div>
  );
};

export default GridOverlay;
